import { RESIZE_WINDOW } from 'actions/types';

export function resizeWindow() {
  return {
    type: RESIZE_WINDOW,
    payload: null
  };
}



// WEBPACK FOOTER //
// ./src/actions/app.js